import { blinqIconStyle } from './styles.css';

interface BlinqIconProps {
  className?: string;
}

export const BlinqIcon: React.FC<React.PropsWithChildren<BlinqIconProps>> = ({ className, children }) => {
  return (
    <svg
      className={className ? `${blinqIconStyle} ${className}` : blinqIconStyle}
      viewBox="0 0 248 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5335_8367)">
        <rect x="0.000305176" width="248" height="248" fill="#F45A57" />
        <rect x="81.8408" width="8.23437" height="248" fill="white" />
        <path
          d="M162.005 77.7438C162.005 98.7435 144.981 115.767 123.981 115.767C102.982 115.767 85.958 98.7435 85.958 77.7438C85.958 56.744 102.982 39.7203 123.981 39.7203C144.981 39.7203 162.005 56.744 162.005 77.7438Z"
          stroke="white"
          strokeWidth="8.23437"
        />
        <path
          d="M162.005 170.256C162.005 191.256 144.981 208.279 123.981 208.279C102.982 208.279 85.958 191.256 85.958 170.256C85.958 149.256 102.982 132.232 123.981 132.232C144.981 132.232 162.005 149.256 162.005 170.256Z"
          stroke="white"
          strokeWidth="8.23437"
        />
      </g>
      {children}
      <defs>
        <clipPath id="clip0_5335_8367">
          <rect width="248" height="248" rx="61.5194" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlinqIconPath: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <path
      fill="currentColor"
      d="M85.333 432.356c47.129 0 85.334-38.204 85.334-85.334H153.6c0 37.703-30.564 68.267-68.267 68.267-37.702 0-68.266-30.564-68.266-68.267v51.209c15.568 20.722 40.352 34.125 68.266 34.125zm0-170.667c47.129 0 85.334 38.204 85.334 85.333H153.6c0-37.703-30.564-68.266-68.267-68.266-37.702 0-68.266 30.563-68.266 68.266v-51.208c15.568-20.722 40.352-34.125 68.266-34.125zm0-17.067c47.129 0 85.334-38.205 85.334-85.333H153.6c0 37.702-30.564 68.267-68.267 68.267-37.702 0-68.266-30.565-68.266-68.267v51.208c15.568 20.722 40.352 34.125 68.266 34.125zm0-170.666c47.129 0 85.334 38.205 85.334 85.333H153.6c0-37.703-30.564-68.267-68.267-68.267-37.702 0-68.266 30.564-68.266 68.267V108.08c15.568-20.722 40.352-34.125 68.266-34.125zM0 0h17.067v512H0V0z"
    ></path>
  );
};
